export const ADD_ITEM = '@DIALOG_MANAGER/ADD_ITEM';
export const ADD_ITEMS = '@DIALOG_MANAGER/ADD_ITEMS';
export const DELETE_ITEM = '@DIALOG_MANAGER/DELETE_ITEM';
export const DELETE_ITEMS = '@DIALOG_MANAGER/DELETE_ITEMS';
